import * as React from 'react';
import * as ReactDataGrid from 'react-data-grid';
import { TourGridColumns } from '../../../../utilities/Enums';
import { tourComparer } from '../ProspectsSubPage';
import {
    getGridProspectTourDisplay,
    ToursColumns,
    ToursGridConatinerProps,
    useProspectTourSortState
} from './recentActivity';

export const ToursGridContainer = ({ prospects, setSelectedTourId }: ToursGridConatinerProps) => {
    const [sortColumn, sortDirection, setSort] = useProspectTourSortState(
        'DESC',
        TourGridColumns.TourTime
    );

    let sortedProspects = prospects.sort(
        sortDirection === 'NONE'
            ? tourComparer(TourGridColumns.TourDate, 'ASC')
            : tourComparer(sortColumn, sortDirection)
    );

    let mappedProspects = sortedProspects.map(getGridProspectTourDisplay);

    return (
        <ReactDataGrid
            columns={[
                ToursColumns.Name,
                ToursColumns.Phone,
                {
                    ...ToursColumns.Email,
                    width: 270,
                },
                ToursColumns.PropertyName,
                ToursColumns.Partner,
                ToursColumns.TourCreationDate,
                ToursColumns.TourDate,
                ToursColumns.TourTime,
                ToursColumns.TourEndTime,
                ToursColumns.Status,
            ]}
            rowGetter={i => mappedProspects[i]}
            rowsCount={mappedProspects.length}
            onGridSort={setSort}
            onRowClick={(_rowIdx: number, row: any) => {
                console.log('row', row)
                if (row && row.tourId) {
                    setSelectedTourId(row.tourId);
                }
            }}
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/toursGridContainer.tsx